import React from 'react'

import './loaderT.css'

export const LoaderT = () => {
  return (
    <div className='typing-loader'></div>
  )
}